import { memo, useContext } from 'react';
import { useAppSelector } from '../../../../../common/store';
import { chatSelector, inputCollectionSelector } from '../../../../../common/store/chat/selectors';
import { SuggestionChipsContainer } from './suggestion-chips-container';
import { SuggestionChip } from './suggestion-chip';
import { SuggestionChipRowContainer } from './suggestion-chip-row-container';
import styled, { useTheme } from 'styled-components';
import { Plug } from '../../../../components/plug';
import { BotChatMessageAvatar } from '../bot-chat-message/bot-chat-message-avatar';
import { ChatContext } from '../../../../contexts/chat-context';
import { SuggestionChip as ISuggestionChip } from '../../../../../common/store/chat/types/suggestion-chip';
import { Freeform } from '../freeform';
import { BookAppointmentImplementation } from '../../../../../common/store/theme/constants/book-appointment-implementation';
import { FreeformTitle } from '../freeform/freeform-title';
import SuggestionsHeader from './suggestions-header';

export const SuggestionChips = () => {
  const storeMessages = useAppSelector(chatSelector);
  const theme = useTheme();
  const { sendSuggestionChipInput } = useContext(ChatContext);
  const inputCollection = useAppSelector(inputCollectionSelector);

  if (!storeMessages.suggestionChips.length) return null;

  const onCLick = (chip: ISuggestionChip) => {
    if (chip?.type !== 'text' && chip?.type !== BookAppointmentImplementation.LIVE_AGENT) return;

    if(!sendSuggestionChipInput) {
      return;
    }

    sendSuggestionChipInput(chip.text);
  };

  return (
    <SuggestionChipsContainer className="voa_chat_bot_suggestion_chips_container">
      
      <SuggestionsHeader>
        <FreeformTitle>You can say things like...</FreeformTitle>
      </SuggestionsHeader>
      {storeMessages.suggestionChips.map((chip, index) => (
        <SuggestionChipRowContainer className="voa_chat_bot_suggestion_chips_item_container" key={chip.text + index}>
          <CustomPlug>
            <BotChatMessageAvatar
              src={theme?.themeConfig?.chatMessages?.botMessage?.avatar?.src}
            />
          </CustomPlug>
          <SuggestionChip
            className='voa_initial_nudge_suggestion_chip_content'
            id="suggestion_btn"
            onClick={() => onCLick(chip)}
            data-type={chip?.type}
          >
            {chip.text}
          </SuggestionChip>
        </SuggestionChipRowContainer>
      ))}
      {!inputCollection && <Freeform />}
    </SuggestionChipsContainer>
  );
};

const CustomPlug = styled(Plug)`
  height: 0;
`